import { J2Download } from '@e3dc-react/icons'
import { CircularProgress, IconButton } from '@mui/material'
import React from 'react'
interface ExportButtonProps {
  isLoading: boolean
  buttonRef: React.RefObject<HTMLButtonElement>
  dataQa?: string
  onClick: (event: React.MouseEvent<HTMLElement>) => Promise<void> | void
}

/**
 * A button to trigger the download of export data in csv format.
 */
const ExportButton: React.FC<ExportButtonProps> = ({ isLoading, buttonRef, dataQa, onClick }) => {
  return (
    <IconButton ref={buttonRef} data-qa={dataQa} size="large" onClick={onClick} disabled={isLoading} sx={{ color: 'primary.main' }}>
      {isLoading ? <CircularProgress size={24} /> : <J2Download />}
    </IconButton>
  )
}

export default ExportButton
